import React from "react";
import Alert from "@mui/material/Alert";
import { NoItemsFound } from "../publisher/NoItemsFound";
import Typography from "@mui/material/Typography";
import { AlwaysOnAppLink } from "../styleguide/AppLink";
import { Path } from "../Path";
import { useHasSlug } from "../sessions/model";

export const Empty = () => {
  const hasUserSlug = useHasSlug();

  return (
    <NoItemsFound>
      {!hasUserSlug && (
        <Alert severity="warning">
          <Typography variant="body2">
            No username set. Please set your username in{" "}
            <AlwaysOnAppLink to={Path.settings().category("about-you")}> settings</AlwaysOnAppLink> to use this feature.
          </Typography>
        </Alert>
      )}
      {hasUserSlug && (
        <Alert severity="info">
          Create a short url to share your game with publishers. You can disable sharing at any time.
        </Alert>
      )}
    </NoItemsFound>
  );
};
